module.exports = __webpack_public_path__ + "img/ico-linkedin-circle.1b36386e.svg";